export function initMonitoring() {
  if (typeof window === "undefined" || !window.performance) {
    return;
  }

  const logMetric = (name, value) => {
    if (import.meta.env.DEV) {
      console.debug(`[web-vitals] ${name}:`, Math.round(value));
    }
  };

  window.addEventListener("load", () => {
    const nav = performance.getEntriesByType("navigation")[0];
    if (nav) {
      logMetric("TTFB", nav.responseStart);
    }

    const paint = performance.getEntriesByType("paint");
    const fcp = paint.find((entry) => entry.name === "first-contentful-paint");
    if (fcp) {
      logMetric("FCP", fcp.startTime);
    }
  });

  try {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.entryType === "largest-contentful-paint") {
          logMetric("LCP", entry.startTime);
        }
      }
    });
    observer.observe({ type: "largest-contentful-paint", buffered: true });
  } catch {
    // LCP observer unsupported in older browsers.
  }
}
